import {Menubar} from "primereact/menubar";
import {Link, useLocation} from "react-router-dom";
import {Button} from "primereact/button";
import {history} from "../../store";
import {Menu} from "primereact/menu";
import {useMemo, useRef} from "react";
import {buildNavigationSections, toMenubarModel} from "./navigationConfig";
import "./Navbar.css";


const LoggedView = props => {
    const menu = useRef(null);
    const onToggleMenu = (event) => {
        menu.current?.toggle(event?.originalEvent || event);
    };

    let items = [
        {
            label: 'Аккаунт',
            items: [
                {label: 'Настройки', icon: 'pi pi-fw pi-cog', command: () => history.push(`/settings`)},
                {label: 'Выйти', icon: 'pi pi-fw pi-power-off', command:() =>  props.logoutHandler()}
            ]
        }
    ]

    if (!props.currentUser) {
        return (
            <ul className="nav navbar-nav pull-xs-right">

                <li className="nav-item">
                    <Button label="Войти" onClick={e => history.push(`/login`)} />
                </li>
            </ul>
        );
    } else {
        return (
            <ul className="nav navbar-nav pull-xs-right">
                <li className="nav-item">
                    <Menu
                        model={items}
                        popup
                        ref={menu}
                        appendTo={typeof document !== 'undefined' ? document.body : null}
                    />
                    <Button label={`${props.currentUser.lastName} ${props.currentUser.firstName}`}
                            className="p-button-text p-button-plain"
                            onClick={onToggleMenu}/>
                </li>
            </ul>
        );
    }
};

const Navbar = props => {
    const location = useLocation();
    const isRootRoute = location.pathname === "/";


    const authorities = (props.currentUser || {authorities: []}).authorities || [];
    const sections = useMemo(() => buildNavigationSections(authorities), [authorities]);
    const items = useMemo(
        () => toMenubarModel(sections, (path) => history.push(path)),
        [sections]
    );
    const shouldShowMainMenu = Boolean(props.currentUser) && !isRootRoute;

    const start = (
        <Link to="/" className="header-brand">
            <span className="header-brand__name">{props.appName}</span>
        </Link>
    );
    const end = <LoggedView currentUser={props.currentUser} logoutHandler={props.logoutHandler}/>;

    return (
        <div>
            <div className="card">
                <Menubar
                    model={items}
                    start={start}
                    end={end}
                    className={`header-menubar ${shouldShowMainMenu ? "" : "header-menubar--minimal"}`.trim()}
                />
            </div>
        </div>
    );
}
export default Navbar
